export const StateMachineEventEnum = {
  Create: "Create",
  Planned: "Planned",
  Assign: "Assign",
  UnAssign: "UnAssign",
  Accept: "Accept",
  Start: "Start",
  ArriveEmpty: "ArriveEmpty",
  Loading: "Loading",
  Driving: "Driving",
  ArriveFull: "ArriveFull",
  Unloading: "Unloading",
  Finish: "Finish",
  Final: "Final",
  Cancel: "Cancel",
  NoShow: "NoShow"
}

